import { ShieldCheck, ArrowRight } from "lucide-react";

const scrollTo = (id) =>
  document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

export const Hero = () => {
  return (
    <section
      data-testid="hero-section"
      className="relative min-h-screen flex items-center overflow-hidden"
    >
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            "url('https://images.pexels.com/photos/30820142/pexels-photo-30820142.jpeg')",
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-r from-[#0B0E14] via-[#0B0E14]/90 to-[#0B0E14]/40" />
      <div className="absolute inset-0 bg-gradient-to-t from-[#0B0E14] via-transparent to-[#0B0E14]/60" />
      <div className="absolute inset-0 grid-bg opacity-40" />

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-10 w-full pt-28 pb-20">
        <div className="max-w-3xl">
          <div
            className="inline-flex items-center gap-2 border border-[#00FFA3]/40 bg-[#00FFA3]/5 px-4 py-2 mb-8 animate-fade-up"
            style={{ animationDelay: "0.05s" }}
          >
            <ShieldCheck size={16} strokeWidth={1.5} className="text-[#00FFA3]" />
            <span className="font-mono-tech text-xs uppercase tracking-[0.2em] text-[#00FFA3]">
              Veteran-Owned Cybersecurity
            </span>
          </div>

          <h1
            className="font-heading font-extrabold text-5xl md:text-6xl lg:text-7xl leading-[0.95] tracking-tight text-white animate-fade-up"
            style={{ animationDelay: "0.15s" }}
          >
            Military Precision.
            <br />
            <span className="text-[#00FFA3]">Next-Gen Defense.</span>
          </h1>

          <p
            className="mt-8 text-lg md:text-xl text-slate-300 leading-relaxed max-w-2xl animate-fade-up"
            style={{ animationDelay: "0.3s" }}
          >
            Enterprise cybersecurity, cloud infrastructure, and intelligent AI
            agents — engineered by veterans for organizations that demand total
            control over their digital frontline.
          </p>

          <div
            className="mt-10 flex flex-col sm:flex-row gap-4 animate-fade-up"
            style={{ animationDelay: "0.45s" }}
          >
            <button
              data-testid="hero-cta-primary"
              onClick={() => scrollTo("contact")}
              className="group inline-flex items-center justify-center gap-2 bg-[#00FFA3] text-[#0B0E14] font-bold px-8 py-4 hover:bg-[#00E5FF] transition-colors"
            >
              Book a Consultation
              <ArrowRight
                size={18}
                className="group-hover:translate-x-1 transition-transform"
              />
            </button>
            <button
              data-testid="hero-cta-secondary"
              onClick={() => scrollTo("services")}
              className="inline-flex items-center justify-center border border-[#00FFA3] text-[#00FFA3] font-bold px-8 py-4 hover:bg-[#00FFA3]/10 transition-colors"
            >
              Explore Services
            </button>
          </div>

          <div
            className="mt-16 grid grid-cols-3 gap-6 max-w-xl animate-fade-up"
            style={{ animationDelay: "0.6s" }}
          >
            {[
              { v: "24/7", l: "Threat Monitoring" },
              { v: "100%", l: "Veteran-Led" },
              { v: "Zero", l: "Trust Architecture" },
            ].map((s) => (
              <div key={s.l} className="border-l border-white/10 pl-4">
                <div className="font-heading font-bold text-2xl md:text-3xl text-white">
                  {s.v}
                </div>
                <div className="font-mono-tech text-[10px] md:text-xs uppercase tracking-wider text-slate-400 mt-1">
                  {s.l}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
